import MuiMenuList, { MenuListProps as MuiMenuListProps } from '@material-ui/core/MenuList';

export type DSMenuListProps = MuiMenuListProps;
export const DSMenuList: typeof MuiMenuList & { displayName?: string } = MuiMenuList;
DSMenuList.displayName = 'DSMenuList';
